import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('div', { 'className': 'external-merch' }, React.createElement('div', {
        'className': 'img-holder',
        'style': { backgroundImage: 'url(' + this.props.previewPhoto + ')' },
        'onClick': () => {
            this.props.openImagesModal([{ src: this.props.photo }]);
        }
    }), React.createElement('div', { 'className': 'cta-holder' }, React.createElement('a', {
        'href': this.props.ctaUrl,
        'className': 'cta',
        'target': '_blank'
    }, this.props.ctaContent)), React.createElement('div', { 'className': 'title' }, this.props.title), React.createElement('div', { 'className': 'description' }, this.props.description));
}